import React, {createContext, useEffect, useReducer} from "react";
import PropTypes from "prop-types";
import UserReducer from "../reducers/userReducer";
import {useUserAccounts} from "../../hooks/useUserAccounts";
import {useKeycloakFunctions} from "../../hooks";

const initialState = {
    userSettings: {},
    loadingUserSettings: false,
    errorUserSettings: null
};

const UserProvider = ({children}) => {
    const {initialized, authenticated} = useKeycloakFunctions();
    const { getUserSettings,
        userSettings,
        loadingGetUserSettings,
        errorGetUserSettings,
        getUser,
        user,
        loadingGetUser,
        errorGetUser
    } = useUserAccounts();
    const [userState, userDispatch] = useReducer(UserReducer, initialState);

    useEffect(() => {
        // User Settings will be requested only in case the user is authenticated
        if (initialized && authenticated) {
            getUser();
            getUserSettings();
        }
    }, [initialized, authenticated]);

    useEffect(() => {
        userDispatch({type: "GET_USER_SETTINGS", payload: {
            userSettings,
            loadingUserSettings: loadingGetUserSettings,
            errorUserSettings: errorGetUserSettings
        }});
    }, [userSettings, loadingGetUserSettings, errorGetUserSettings]);

    useEffect(() => {
        userDispatch({type: "GET_USER", payload: {
            user,
            loadingUser: loadingGetUser,
            errorUser: errorGetUser
        }});
    }, [user, loadingGetUser, errorGetUser]);

    return (
        <UserContext.Provider value={[userState, userDispatch]}>
            {children}
        </UserContext.Provider>
    );
};

UserProvider.propTypes = {
    children: PropTypes.any
};

export const UserContext = createContext(initialState);
export default UserProvider;
